import React, { useState, useCallback } from 'react'
import Modal from '../../components/Modal'
import { CopyPeriod } from './ModalTabs'
import Confirmation from '../../components/Confirmation/Confirmation'

export default function CopyScheduleModal({ open, closeModal, data }) {
  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  return (
    <Modal open={open} onClose={handleClose} closeOnOverlayClick={true} closeOnEsc={true}>
      <CopyPeriod closeModal={closeModal} data={data} addMode={true} />
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}

